export default __webpack_public_path__ + "static/media/sample.fafa6b2e.jpg";